// extracted by mini-css-extract-plugin
module.exports = {"linkContainer":"Brand_linkContainer__PqJQq","headerName":"Brand_headerName__Iu1h3","hoverPointer":"Brand_hoverPointer__HsbnU"};